import * as SessionActions from './session.actions';

import {createFeatureSelector, createSelector} from '@ngrx/store';
import {UtilisateurModel} from '../../../models/main/utilisateur.model';
import {DossierModel} from '../../../models/main/dossier.model';
import {PermissionModel} from '../../../models/main/permission.model';
import {ReponseModel} from '../../../models/reponse.model';


export interface SessionState {
	utilisateur: UtilisateurModel;
	dossier: DossierModel;
	permissions: PermissionModel[];
	estAdministrateur : boolean;
	reponse: ReponseModel;
}


export const initialeSessionState: SessionState = {
	utilisateur: undefined,
	dossier: undefined,
	permissions: [],
	estAdministrateur: false,
	reponse: new ReponseModel(false, false),
}

export function SessionReducer(state = initialeSessionState, action: SessionActions.actions): SessionState {
	switch (action.type) {

		// DEMANDE
		case SessionActions.sessionActionsType.DEMANDE_SESSION : {
			return {
				...state,
				reponse: new ReponseModel(false, false)
			};
		}

		// DEMANDE OK
		case SessionActions.sessionActionsType.DEMANDE_SESSION_OK : {
			return {
				...state,
				reponse: new ReponseModel(true, false),
				utilisateur: action.payload.utilisateur,
				dossier: action.payload.dossier,
				permissions: action.payload.permissions,
				estAdministrateur: action.payload.estAdministrateur
			};
		}

		// DEMANDE KO
		case SessionActions.sessionActionsType.DEMANDE_SESSION_KO : {
			return {
				...state,
				reponse: new ReponseModel(true, true)
			};
		}

		default :
			return state;
	}
}


// selectors
const getSessionFeatureState = createFeatureSelector<SessionState>('session');


export const selectSessionUtilisateur = createSelector(
	getSessionFeatureState,
	(state: SessionState) => state.utilisateur
);

export const selectSessionDossier = createSelector(
	getSessionFeatureState,
	(state: SessionState) => state.dossier
);

export const selectSessionReponse = createSelector(
	getSessionFeatureState,
	(state: SessionState) => state.reponse
);

export const selectSessionPermissions = createSelector(
	getSessionFeatureState,
	(state: SessionState) => state.permissions
);

export const selectSessionEstAdministrateur = createSelector(
	getSessionFeatureState,
	(state: SessionState) => state.estAdministrateur
);




